import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-023bbef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-name-text" }

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import RankingChart, { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { getChartPieMixedPalette } from '@/utils/chart-theme-colors'

interface ClassificationItem {
  name: string
  percentage: number
  /** 与时长占比接口 `group_id` 一致，用于软件列表筛分类 */
  group_id?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'time-proportion-classification',
  props: {
    title: { default: undefined },
    data: { default: () => [] },
    rowClickable: { type: Boolean, default: true }
  },
  emits: ["timeRangeChange", "itemClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const { t, locale } = useI18n()
const displayTitle = computed(() => {
  void locale.value
  return props.title ?? t('softwareUsage.durationProportionClassificationTitle')
})

const emit = __emit

const loading = ref(false)
const timeRange = ref<TimeRange>(TimeRange.DAYS_30)
const colors = computed(() => getChartPieMixedPalette().slice(0, 5))

const chartData = computed(() => {
  return props.data.map(item => ({
    name: item.name,
    percentage: item.percentage,
    count: item.percentage, // RankingChart需要count字段，但实际使用percentage
    group_id: item.group_id,
  }))
})

function onRankingItemClick(item: RankingItem) {
  const pct = Number(item.percentage ?? item.count ?? 0)
  if (!Number.isFinite(pct) || pct <= 0) return
  const gid = item.group_id
  if (gid == null || !Number.isFinite(Number(gid))) return
  emit('itemClick', { groupId: Number(gid), name: String(item.name ?? ''), percentage: pct })
}

function handleTimeRangeChange(value: TimeRange) {
  emit('timeRangeChange', value)
}

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: displayTitle.value,
    data: chartData.value,
    "time-range": timeRange.value,
    "show-time-range": true,
    "show-index": false,
    "use-percentage": true,
    "percentage-key": 'percentage',
    colors: colors.value,
    "max-items": 999,
    "row-clickable": _ctx.rowClickable,
    loading: loading.value,
    "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
    "onUpdate:timeRange": handleTimeRangeChange,
    onItemClick: onRankingItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        onChange: handleTimeRangeChange
      }, null, 8, ["modelValue"])
    ]),
    "item-name": _withCtx(({ item }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(item.name), 1)
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "colors", "row-clickable", "loading"]))
}
}

})